export default {
    question: 'Are you sure you want to delete this post?',
    notice: 'Attention: This action cannot be undone.',
    action: 'Yes, delete now',
    success: 'The post was successfully deleted.'
}
